import React, { useRef, lazy } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { ScrollReveal } from './ScrollReveal';
export const Technology = () => {
  const ref = useRef(null);
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ['start end', 'end start']
  });
  const yText = useTransform(scrollYProgress, [0, 1], ['0%', '15%']);
  const yImage = useTransform(scrollYProgress, [0, 1], ['0%', '-10%']);
  return <section ref={ref} id="technology" className="py-32 md:py-48 bg-brand-darker relative overflow-hidden" data-id="element-165">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 relative z-10" data-id="element-166">
        <motion.div style={{
        y: yText
      }} className="w-full lg:w-5/12 pr-0 lg:pr-12" data-id="element-167">
          <ScrollReveal blur scale data-id="element-168">
            <h2 className="text-5xl md:text-6xl lg:text-7xl font-black text-brand-light mb-8 tracking-tighter leading-[1.05] text-balance" data-id="element-169">
              Détatouage Laser Avancé à Martigny
            </h2>
          </ScrollReveal>

          <ScrollReveal delay={0.2} blur data-id="element-170">
            <h3 className="text-xl md:text-2xl font-medium text-brand-gray mb-10 tracking-tight leading-snug" data-id="element-171">
              Suppression de Tatouage avec Technologies Picoseconde et
              Q-Switched
            </h3>
          </ScrollReveal>

          <ScrollReveal delay={0.3} blur data-id="element-172">
            <p className="text-lg md:text-xl text-brand-gray/80 font-light leading-relaxed" data-id="element-173">
              En matière de détatouage laser picoseconde et de systèmes
              Q-Switched (nanoseconde), la technologie fait toute la différence.
              Chez Dispel Your Tattoo, j'utilise les deux technologies les plus
              reconnues du domaine, afin d'optimiser chaque traitement selon le
              type d'encre, sa profondeur et la complexité du tatouage.
            </p>
          </ScrollReveal>
        </motion.div>
      </div>

      {/* Bleeding Image Content (Right) */}
      <motion.div style={{
      y: yImage
    }} className="w-full h-[50vh] lg:h-[80vh] lg:absolute lg:top-1/2 lg:-translate-y-1/2 lg:right-0 lg:w-[55%] mt-16 lg:mt-0 z-0" data-id="element-174">
        <ScrollReveal clipReveal="left" duration={1.5} className="h-full w-full" data-id="element-175">
          <img src="https://cdn.magicpatterns.com/uploads/gPuGLFxqLPD9w6gA9pCBvR/IMG_2731-PROOF-THOMAS-MASOTTI.jpg" alt="Écran de la machine laser picoseconde utilisée pour le détatouage chez Dispel Your Tattoo" className="w-full h-full object-cover grayscale-[15%]" loading="lazy" data-id="element-176" />
        </ScrollReveal>
      </motion.div>
    </section>;
};